import { Badge, toast, Tooltip } from "@altimateai/lego";
import { CloseIcon } from "@/assets/icons";
import { AddTagToNodeRequest, BaseTag } from "../types";
import { useMutation } from "@tanstack/react-query";
import { removeTagFromNode } from "@/helpers/apis";
import { LoadingButton, Stack } from "@altimateai/lego";
import { isAdmin, isOwner } from "@/services/auth";
interface TagProps {
  tag: BaseTag;
  entity: AddTagToNodeRequest["entity"];
  onRemove: () => void;
}

export const Tag = ({ tag, entity, onRemove }: TagProps) => {
  const { mutate: removeTag, isPending: isLoading } = useMutation({
    mutationFn: () => removeTagFromNode(tag.rk!, entity),
    onSuccess: () => {
      toast({ description: "Tag removed successfully" });
      onRemove();
    },
    onError: error => {
      toast({ description: error.message, variant: "destructive" });
    },
  });

  // Only allow removal when rk is present (tags without rk are display-only) and display_name is set
  const canRemoveTag = (isOwner() || isAdmin()) && Boolean(tag.display_name) && Boolean(tag.rk);

  const tagName = tag.display_name || tag.name || tag.rk;
  return (
    <Badge
      variant="secondary"
      className="al-group  al-relative !al-bg-bg-brand al-cursor-default !al-font-normal focus:al-outline al-text-nowrap al-py-1.5"
    >
      <Stack align="center">
        <span>{tagName}</span>
        {canRemoveTag ? (
          <Tooltip title={`Remove "${tagName}"`}>
            <LoadingButton
              onClick={e => {
                e.stopPropagation();
                removeTag();
              }}
              loading={isLoading}
              className="al-absolute al-right-0 al-top-1 al-p-1 al-bg-white !al-rounded-full al-opacity-0 focus:al-opacity-100 group-focus:al-opacity-100 group-hover:al-opacity-100 !al-p-[4px] al-h-auto [&_svg]:al-text-gray-500 [&_svg]:hover:al-text-white"
            >
              <CloseIcon className="!al-h-3 !al-w-3" />
            </LoadingButton>
          </Tooltip>
        ) : null}
      </Stack>
    </Badge>
  );
};
